import React, { useEffect, useState } from "react";
import ApiService from "../../Core/Service/ApiService";
import { MDBBtn, MDBCheckbox } from "mdb-react-ui-kit";

const BranchSelect = React.memo(props=>{
    const [initialzed, setInitialized] = useState(false);
    const [branches, setBranches] = useState([]);

    useEffect(() => {
        ApiService.get('/branches/all').then(response=>{
            setInitialized(false);
            setBranches(response.data.branches.map(br=>({
                ...br,
                checked: false
            })));
        })
    }, []);

    useEffect(()=>{
        if(branches?.length && props.initialSelectedBranches?.length > 0 && !initialzed) {
            setBranches(branches.map(br=>({
                ...br,
                checked: props.initialSelectedBranches.includes(br.id)
            })))
            setInitialized(true);
        }
    }, [branches, props.initialSelectedBranches])

    const selectAllBranch = () => {
        setBranches(branches.map(br=>({
            ...br,
            checked: true
        })))
        props.onChange && props.onChange(branches.map(br=>br.id));
    }
    const unSelectAllBranch = () => {
        setBranches(branches.map(br=>({
            ...br,
            checked: false
        })))
        props.onChange && props.onChange([]);
    }
    const invertSelectBranch = () => {
        const new_branches = branches.map(br=>({
            ...br,
            checked: !br.checked
        }));

        setBranches(new_branches);
        props.onChange && props.onChange(new_branches.filter(br=>br.checked).map(br=>br.id))
    }
    const handleBranchCheckChange = (e, branch_id) => {
        const new_branches = branches.map(br=>{
            return {
                ...br,
                checked: (br.id == branch_id) ? e.target.checked : br.checked
            }
        })
        
        setBranches(new_branches);
        props.onChange && props.onChange(new_branches.filter(br=>br.checked).map(br=>br.id));
    }

    return (
    <div className={`branch-select ${props.className} ${props.readonly ? 'disabled-opacity-1' : ''}`}>
        <div className="d-flex align-items-center">
            <label className={`${props.required ? 'required' : ''}`}>Branches:</label>
            {props.readonly != true && (<>
                <MDBBtn className="ms-4 py-1 px-2" color="link" onClick={selectAllBranch}>Select All</MDBBtn>
                <MDBBtn className="ms-2 py-1 px-2" color="link" onClick={unSelectAllBranch}>Select None</MDBBtn>
                <MDBBtn className="ms-2 py-1 px-2" color="link" onClick={invertSelectBranch}>Invert Selection</MDBBtn>
            </>)}
        </div>
        <div className="d-flex align-items-center mt-2">
            {branches?.map((branch, index) => (
            <div className="d-flex align-items-center me-4" key={index}>
                <MDBCheckbox checked={branch.checked} onChange={e=>handleBranchCheckChange(e, branch.id)} />
                <span className="ms-1">{branch.site_name}</span>
            </div>
            ))}
        </div>
        {props.inputError && <div className="error">{props.inputError}</div>}
    </div>
    )
});

export default BranchSelect;